<template>
  <div class="lottery-contain page-container">
    <van-nav-bar
      v-if="!$route.query.terminal"
      class="lottery-nav"
      title=""
      fixed
      :z-index="10"
      @click-left="clickNavBack"
      left-arrow>
    </van-nav-bar>

    <div
      class="lottery-content"
      :style="'background-image: url(' + params.lotteryBackImg + ')'">
      <div class="center-bg">
        <div class="center-bg-box">
          <div class="lotter-box">
            <div
              :class="['item', { active: currentIndex === index }]"
              v-for="(item, index) in prizeData"
              :key="index"
              @click="start(index)">
              <img :src="item.pic" alt="" />
            </div>
          </div>
        </div>
        <div class="button-box">
          <div
            :class="['button-left', { active: lotteryType == 1 }]"
            @click="onchangeType(1)">
            加息券
          </div>
          <div
            :class="['button-right', { active: lotteryType == 3 }]"
            @click="onchangeType(3)">
            满减券
          </div>
        </div>
        <div class="rule-bg">
          <div class="rule-title">规则说明:</div>
          <div class="content-bg">
            <div>1、加息券和满减券各抽一次;</div>
            <div>2、加息券和满减券均不可叠加使用;</div>
            <div>3、加息券、满减券可以与属性为“任意叠加”的福利券叠加;</div>
          </div>
        </div>
        <div style="height: 5px"></div>
      </div>
    </div>
    <sevensuccess-pop
      :show.sync="showSuccess"
      :price="lotteryType == 1 ? `${prizePrice}%` : prizePrice"
      :unit="lotteryType == 1 ? '' : '¥'"
      :title="lotteryType == 1 ? '加息券' : '满减券'"
      :desc="condStartAmt"
      :lotteryType="lotteryType"
      @close="showSuccess = false"
      @commitUse="clickUse" />
  </div>
</template>
      
      <script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js" />
      <script>
import defaultBackgroundImg from "../../assets/img/lottery/seven/seven_bg.png"
import defaultNormalImg from "../../assets/img/lottery/seven/seven_normal_box.png"
import defaultStartImg from "../../assets/img/lottery/seven/seven_start_bg.png"
import NativeShare from "nativeshare"
import * as LotteryApi from "@/api/lottery"
import * as ShareApi from "@/api/share"
import { mapGetters } from "vuex"
import SevensuccessPop from "./components/sevensuccessPop.vue"

const defaultImagePath =
  "https://tianbaolian.oss-cn-shanghai-finance-1-pub.aliyuncs.com/baolian/2021120810/17b30c56-17d4-4f40-8d18-1343cf613dde.jpg"

export default {
  name: "lottery",
  components: {
    SevensuccessPop
  },

  data() {
    return {
      screenWidth: document.documentElement.clientWidth,
      lotteryWidth: 0,
      //转盘上的奖品数据
      prizeData: [
        {
          name: "0",
          pic: defaultNormalImg
        },
        {
          name: "1",
          pic: defaultNormalImg
        },
        {
          name: "2",
          pic: defaultNormalImg
        },
        {
          name: "3",
          pic: defaultNormalImg
        },
        {
          name: "开始按钮",
          pic: defaultStartImg
        },
        {
          name: "5",
          pic: defaultNormalImg
        },
        {
          name: "6",
          pic: defaultNormalImg
        },
        {
          name: "7",
          pic: defaultNormalImg
        },
        {
          name: "8",
          pic: defaultNormalImg
        }
      ],
      prizeList: [],
      // 奖品高亮顺序
      prizeSort: [0, 1, 2, 5, 8, 7, 6, 3],
      //   prizeSort: [0, 3, 6, 7, 8, 5, 2, 1],
      currentIndex: -1, // 当前位置
      isRunning: false, // 是否正在抽奖
      speed: 10, // 抽奖转动速度
      timerIns: null, // 定时器实例
      currentRunCount: 0, // 已跑次数
      totalRunCount: 32, // 总共跑动次数 8的倍数
      prizeId: 0, // 中奖id

      lotteryType: 1, // 1 加息券 3 满减券
      showSuccess: false, //是否抽到奖品
      condStartAmt: "",
      prizePrice: 0,

      params: {
        activityId: "", // 活动ID
        token: this.$route.query.token || "",

        title: "", //标题
        imagePath: defaultImagePath, //分享图片链接
        shareDescription: "", //描述
        lotteryBackImg: defaultBackgroundImg, //抽奖背景图片链接
        upNumber: 2 // 抽奖次数
      },
      share: {
        title: "幸运抽奖", //标题
        desc: "转转赢大奖，好运享不停！", //描述
        link: location.href.split("&token=")[0],
        imgUrl:
          "https://tianbaolian.oss-cn-shanghai-finance-1-pub.aliyuncs.com/dev/share.png"
      },
      nativeShare: NativeShare,

      //临时存放分享数据的信息
      tempShareTitle: "天安金交中心",
      tempShareDesc: "",
      tempShareImgUrl: ""
    }
  },

  computed: {
    ...mapGetters(["channel"])
  },
  beforeMount() {
    this.lotteryWidth = this.screenWidth * (1 - 0)
    console.log("lotteryWidth == %O", this.lotteryWidth)
    if (this.channel.toLowerCase() != "ta") {
      this.$router.push({ name: "home" })
      return
    }
    LotteryApi.julyLoad()
      .then((data) => {
        if (data) {
          this.params.imagePath = data.imagePath || defaultImagePath //分享图片链接
          this.params.title = data.title || "" //标题
          this.params.shareDescription = data.shareDescription || "" //描述
          this.params.lotteryBackImg =
            data.lotteryBackImg || defaultBackgroundImg //抽奖背景图片链接
          this.params.upNumber = data.upNumber

          this.params.activityId = data.id || ""

          this.initData()
          this.loadCard()
        }
      })
      .catch((e) => {
        this.$toast(e.msg || e.message)
        this.initData()
      })
  },
  created() {
    this.tempShareDesc = this.$store.state.share.shareOriginData.desc
    this.tempShareImgUrl = this.$store.state.share.shareOriginData.imgUrl

    console.log("query == %O", this.$route.query)
  },
  destroyed() {
    this.$store.state.share.shareOriginData.title = this.tempShareTitle
    this.$store.state.share.shareOriginData.desc = this.tempShareDesc
    this.$store.state.share.shareOriginData.imgUrl = this.tempShareImgUrl
  },
  methods: {
    loadCard() {
      LotteryApi.juneCard(this.params.activityId)
        .then((data) => {
          this.prizeList = data.cardLists
          // this.prizeList.splice(4, 0, { id: "-1", name: "start" })
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
          if (e.code == 4000) {
            // this.clickNavBack()
            this.$router.push({ name: "home" })
          }
        })
    },
    initData() {
      //初始化分享相关信息
      this.share.title = this.params.title
      this.share.desc = this.params.shareDescription
      this.share.imgUrl = this.params.imagePath

      console.log("shareInfo == %O", this.$store.state.share.shareOriginData)
      this.$store.state.share.shareOriginData.title = this.params.title
      this.$store.state.share.shareOriginData.desc =
        this.params.shareDescription
      this.$store.state.share.shareOriginData.imgUrl = this.params.imagePath
      this.$store.state.share.shareOriginData.link = this.params.link
      console.log(
        "new shareInfo == %O",
        this.$store.state.share.shareOriginData
      )
      this.initSignature()
    },
    initSignature() {
      let url = location.href.split("#")[0]
      console.log("this.share.link == " + this.share.link)
      ShareApi.getSignature({
        url: url
      })
        .then((data) => {
          //通过config接口注入权限验证配置  只要调后端接口就可以了。后端会把那些信息处理好，然后通过一个接口返给你这些参数
          //拼接sha1加密字符串
          if (this.isWechant()) {
            wx.config({
              // development production
              debug: process.env.NODE_ENV == "development",
              // debug: process.env.NODE_ENV != "production", // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              timestamp: data.timestamp,
              appId: data.appid, // 必填，公众号的唯一标
              nonceStr: data.noncestr, // 必填，生成签名的时间戳
              signature: data.signature, // 必填，生成签名的随机串
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData"
              ] // 必填，需要使用的JS接口列表
            })
            //通过ready接口处理成功验证
            wx.ready(() => {
              //需在用户可能点击分享按钮前就先调用
              //分享到朋友圈"
              wx.updateTimelineShareData({
                title: this.share.title,
                link: this.share.link, // 分享链接
                imgUrl: this.share.imgUrl // 分享图标
              })
              //分享给朋友
              wx.updateAppMessageShareData({
                title: this.share.title,
                link: this.share.link, // 分享链接
                imgUrl: this.share.imgUrl, // 分享图标
                desc: this.share.desc // 分享描述
              })
            })
          } else {
            this.nativeShare = new NativeShare({
              wechatConfig: {
                timestamp: data.timestamp,
                appId: data.appid, // 必填，公众号的唯一标
                nonceStr: data.noncestr, // 必填，生成签名的时间戳
                signature: data.signature // 必填，生成签名的随机串
              },
              syncDescToTag: false,
              syncIconToTag: false,
              syncTitleToTag: false
            })

            // 设置分享文案
            this.nativeShare.setShareData({
              icon: this.share.imgUrl,
              link: this.share.link,
              title: this.share.title,
              desc: this.share.desc
              // from: "@fa-ge",
              // 以下两个个回调目前只有在微信和百度APP中很好的支持
              //success: noop,
              //fail: noop,

              // 只有微信支持
              //trigger: noop
            })
            console.log("nativeShare == %O", this.nativeShare)
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    clickNavBack() {
      if (this.$route.query.paySuccessEnter) {
        this.$router.push({ name: "home" })
      } else {
        this.goableBack()
      }
    },
    getRandomNum() {
      // const num = Math.floor(Math.random() * 9)
      // if (num === 4) {
      //  console.log(">>>>>不能为4")
      //  return this.getRandomNum()
      // } else {
      //  return num
      // }
      // 这里一次必然可以取到 时间为1次
      return this.prizeSort[Math.floor(Math.random() * this.prizeSort.length)]
    },
    totalRunStep() {
      //   console.log(
      //     "prizeSort.indexOf(this.prizeId) == %O",
      //     this.prizeSort.indexOf(this.prizeId)
      //   )
      return this.totalRunCount + this.prizeSort.indexOf(this.prizeId)
    },
    start(i) {
      if (i === 4 && !this.isRunning) {
        this._showLoading()
        LotteryApi.julyLottery(this.lotteryType)
          .then((data) => {
            this._dismissLoading()
            let isSuccess = false
            for (let index = 0; index < this.prizeList.length; index++) {
              const element = this.prizeList[index]
              if (element.id === data.id) {
                isSuccess = true
                this.prizeId = this.prizeSort[index > 7 ? 7 : index]
                this.condStartAmt = `满${(data.condStartAmt / 100).toFixed(
                  0
                )}元可用`
                this.prizePrice =
                  this.lotteryType == 1
                    ? element.amount / 100
                    : (element.amount / 100).toFixed(0)
                // 重置数据
                this.currentRunCount = 0
                this.speed = 100
                this.isRunning = true

                this.startRun()
              }
            }
            if (!isSuccess) {
              this.$toast("谢谢参与！")
            }
          })
          .catch((e) => {
            this._dismissLoading()
            this.$toast(e.msg || e.message)
            if (e.code == 4000) {
              this.clickNavBack()
            }
          })
      }
    },
    startRun() {
      this.stopRun()
      //   console.log(
      //     "已跑次数 == %O, 总共跑动次数 == %O",
      //     this.currentRunCount,
      //     this.totalRunStep()
      //   )
      // 要执行总步数
      // 已走步数超过
      if (this.currentRunCount > this.totalRunStep()) {
        this.isRunning = false
        this.showSuccess = true
        return
      }
      this.currentIndex = this.prizeSort[this.currentRunCount % 8]
      // 如果当前步数超过了2/3则速度慢下来
      if (this.currentRunCount > Math.floor((this.totalRunCount * 2) / 3)) {
        this.speed = this.speed + Math.floor(this.currentRunCount / 3)
        // console.log("速度>>>> == ", this.speed)
      }
      this.timerIns = setTimeout(() => {
        this.currentRunCount++
        this.startRun()
      }, this.speed)
    },
    stopRun() {
      this.timerIns && clearTimeout(this.timerIns)
    },
    onchangeType(type) {
      if (!this.isRunning) {
        this.lotteryType = type
      }
    },
    clickUse() {
      this.$router.push("/invest")
    },
    //浏览器分享（不包含微信浏览器）
    clickShare(command) {
      try {
        const ua = navigator.userAgent.toLowerCase()
        console.log("ua == %O, br == %O", ua, this.isWechant())
        //判断是否是安卓系统
        const isAndroid = ua.indexOf("android") > -1 || ua.indexOf("adr") > -1
        //判断是否是iOS系统
        const isiOS = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/)
        if (isAndroid) {
          console.log("Android")
          // window.jsBridge.finis()//
        } else if (isiOS) {
          console.log("iOS")
          // window.webkit.messageHandles.finis.postMessage()
        }
        this.nativeShare.call(command)
        // 如果是分享到微信则需要 nativeShare.call('wechatFriend')
        // 类似的命令下面有介绍
        console.log("此浏览器支持跳转")
      } catch (err) {
        // 如果不支持，你可以在这里做降级处理
        this.$toast("暂不支持该浏览器")
        console.log("此浏览器不支持跳转")
      }
    }
  }
}
</script>
      
      <style lang="less" scoped>
.lottery-nav {
  background-color: transparent;
  &::after {
    display: none;
  }
}
.lottery-content {
  background-image: url(../../assets/img/lottery/seven/seven_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  // min-height: calc(100vh - 45px);
  min-height: 100vh;
  margin-top: -45px;
  //   height: 812px;
  //   height: 100%;

  .center-bg {
    margin: 0;
    width: 100%;
    height: 100%;
    padding-top: 60px;
    .center-bg-box {
      background-image: url(../../assets/img/lottery/seven/seven_lotter_bg.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 402px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 40px;
      width: calc(100% - 80px);
      [v-cloak] {
        display: none;
      }
      .lotter-box {
        // background-color: rgba(0, 234, 123, 0.8);
        margin-top: 92px;
        width: 204px;
        height: 188px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .item {
          width: 68px;
          height: 62.6px;
          position: relative;
        }
        .item:nth-of-type(5) {
          cursor: pointer;
        }
        .item img {
          background-color: transparent;
          width: 100%;
          height: 100%;
        }
        .active {
          //   box-shadow: 2px 2px 10px #fff;
          background-image: url(../../assets/img/lottery/seven/seven_scoll_box.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
    .button-box {
      background-image: url(../../assets/img/lottery/seven/seven_btn_bg.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 40px;
      margin-top: -15px;
      margin-left: 90px;
      width: calc(100% - 180px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: white;
      font-size: 16px;
      text-align: center;
      .button-right,
      .button-left {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 80%;
        width: calc(50% - 5px);
      }
      .button-left {
        margin-left: 5px;
      }
      .button-right {
        margin-right: 5px;
      }
      .active {
        font-weight: 700;
        background-image: url(../../assets/img/lottery/seven/seven_btn_text_bg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
  }
  .rule-bg {
    background-image: url(../../assets/img/lottery/seven/seven_sm_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 75px 28px 40px 19px;
    height: 152px;
    .rule-title {
      color: white;
      margin: 0 20px;
      padding-top: 15px;
      font-size: 13px;
      font-weight: 600;
    }
    .content-bg {
      color: white;
      margin: 0px 20px;
      font-size: 13px;
      padding-bottom: 40px;
      div {
        margin: 5px 0;
      }
    }
  }
}
</style>
      